<template>
  <div class="lg:min-w-mobile relative h-full">
    <div class=" flex h-full">
      <div class="mobile mobile__wrapper lg:my-auto">
        <!-- <img
      src="/assets/Desktop/4_Test/IBL_Sito_ControCorrente_iPhone_Test.png"
    /> -->
        <div class="mobile__top">
          <img
            class="lg:hidden"
            src="
            /assets/Mobile/4_Test/IBL_Sito_ControCorrente_Logo_PopUp_Test.png
          "
          />
        </div>
        <div class="mobile__left" />
        <div class=" mobile__main whitespace-nowrap flex flex-col px-3 py-2">
          <p class="text-primary text-2xl font-black">Calcolo annuo</p>
          <dl class=" text-gray-500">
            <dt class=" text-lg font-bold border-t border-gray-500">
              Canone senza sconti
            </dt>
            <dd
              class="text-4xl font-black"
              v-text="`${(yearlyFee && yearlyFee.toLocaleString()) || 0}€`"
            />

            <dt class="text-primary text-lg font-bold border-t border-gray-500">
              Canone scontato
            </dt>
            <dd
              class="text-primary text-4xl font-black"
              v-text="
                `${(discountedYearlyFee &&
                  discountedYearlyFee.toLocaleString()) ||
                  0}€`
              "
            />

            <dt class="text-lg font-bold border-t border-gray-500">
              Rendimento netto
            </dt>
            <dd
              class="text-4xl font-black"
              v-text="`${(gains && gains.toLocaleString()) || 0}€`"
            />
          </dl>

          <div class="mt-auto">
            <dt class="text-primary text-lg font-bold text-center">
              Risultato finale
            </dt>
            <div
              class="bg-primary rounded-2xl p-2 mb-4 text-4xl font-black text-center text-white uppercase"
              v-text="`${(profit && profit.toLocaleString()) || ''}€`"
            />

            <div
              class="border-primary rounded-2xl whitespace-nowrap text-primary p-2 mb-4 text-2xl font-black text-center uppercase border cursor-pointer"
            >
              <a
                :href="apriContoUrl"
                target="_blank"
                v-text="'Apri il conto'"
              />
            </div>
          </div>
        </div>
        <div class="mobile__right" />
        <div class="mobile__bottom" />
      </div>
      <div class="disclaimer text-sm" v-text="disclaimer"></div>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    yearlyFee: Number,
    discountedYearlyFee: Number,
    gains: Number,
    profit: Number,
    disclaimer: String
  }
};
</script>
<style scoped>
.mobile__wrapper {
  @apply grid mx-auto;
  grid-template-columns: 0 1fr 0;
  grid-template-rows: min-content 1fr 0;
  grid-template-areas:
    "top top top "
    "left main right "
    "bottom bottom bottom ";
}

.mobile__main {
  grid-area: main;
  background-color: white;
  background-clip: padding-box;
}
.mobile__before {
  grid-area: before;
}
.mobile__top {
  grid-area: top;
}
.mobile__left {
  grid-area: left;
}
.mobile__right {
  grid-area: right;
}
.mobile__bottom {
  grid-area: bottom;
}

@screen lg {
  .mobile__wrapper {
    @apply bg-cover bg-no-repeat;
    width: 278px;
    height: 549px;
    grid-template-columns: 2rem 1fr 2rem;
    grid-template-rows: 6rem 1fr 2rem;
    background-image: url("/assets/Desktop/4_Test/IBL_Sito_ControCorrente_iPhone_Test.png");
  }
}

.disclaimer {
  @apply max-h-full  py-10 text-center transform rotate-180;
  writing-mode: vertical-rl;
}
</style>
